(function() {
  "use strict";
  /**
   * [String字符串扩展添加format函数]
   * @return {[String]} [返回新的字符串]
   * 用法：
   * "My Name is {0},age is {1}".format('wang',25);
   */
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/\{(\d+)\}/g, function(s, i) {
      return args[i];
    });
  };

  /**
   * [Date日期添加格式化format函数]
   * @param  {[String]} fmt [格式化字符串]
   * @return {[String]}     [返回格式化后的字符串]
   * 用法:
   * (new Date()).pattern("yyyy-MM-dd hh:mm:ss.S")   ==> 2006-07-02 08:09:04.423
   * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss")   ==> 2009-03-10 二 20:09:04
   * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss")  ==> 2009-03-10 周二 08:09:04
   * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
   * (new Date()).pattern("yyyy-M-d h:m:s.S")        ==> 2006-7-2 8:9:4.18
   */
  Date.prototype.format = function(fmt) {
    var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, //小时
      "H+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    var week = {
      "0": "天",
      "1": "一",
      "2": "二",
      "3": "三",
      "4": "四",
      "5": "五",
      "6": "六"
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "星期" : "周") : "") + week[this.getDay() + ""]);
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  };

  /**
   * [为数组扩展Append，可以添加数组]
   * @param  {[Array]} otherArray [需要加入的数组]
   * @return {[Array]}            [返回新的数组]
   */
  Array.prototype.append = function(otherArray){
    otherArray.forEach(function(v){this.push(v);},this);
  };

}());



// WEBPACK FOOTER //
// ./src/service/utils.js